// extracted by mini-css-extract-plugin
module.exports = {"whiteBg":"webinar-read_whiteBg__kAotR","bottom":"webinar-read_bottom__64iiP","author":"webinar-read_author__JFKTE"};